import { Directive, HostBinding, Input } from '@angular/core';
import { InputBoxDirective } from './input-box.directive';

@Directive({
  standalone: true,
  selector: `
    input[type="date"][vsInput],
  `,
  hostDirectives: [InputBoxDirective],
})
export class DateInputDirective {
  @HostBinding('class') get styles() {
    const clear = `[&::-webkit-calendar-picker-indicator]:hidden`;
    const box = `px-3 h-10 w-full`;
    return `theme-primary-inherit ${this.showDefaultPicker ? '' : clear} ${box}`;
  }

  @Input() showDefaultPicker = false;
}
